import { logError } from "@/lib/server-logger";
import type {
  GetUserByUserIdQueryUser,
  GetUserByUserIdQueryUserWithConsumer,
  GetUserByUserIdQueryUserWithInsurances,
} from "@frontend/lib/graphql/gql-types";
async function getUserByIdBase<T>(
  userId: string,
  includeConsumers = false,
  includeInsurances = false,
) {
  const fetchParams: Record<string, string> = {
    userId,
    ...(includeConsumers ? { includeConsumers: "true" } : {}),
    ...(includeInsurances ? { includeInsurances: "true" } : {}),
  };
  const searchParams = new URLSearchParams(fetchParams);
  const fetchUrl = `/api/user/get-by-id?${searchParams.toString()}`;

  try {
    const data = (await (await fetch(fetchUrl)).json()) as T | null;
    return data;
  } catch (error) {
    logError("Error fetching user by ID", error, { userId });
    return null;
  }
}

export const getUserById = async (userId: string) =>
  await getUserByIdBase<GetUserByUserIdQueryUser>(userId);

export const getUserByIdWithConsumers = async (userId: string) =>
  await getUserByIdBase<GetUserByUserIdQueryUserWithConsumer>(userId, true);

export const getUserByIdWithConsumersAndInsurances = async (userId: string) =>
  await getUserByIdBase<GetUserByUserIdQueryUserWithInsurances>(
    userId,
    true,
    true,
  );
